export const isEmbedded = window.self !== window.top && /^\/embedded\//.test(window.location.pathname);

export const getIframe = (): HTMLIFrameElement | undefined => {
  const iframes = window.parent.document.getElementsByTagName("iframe");
  const iframe = Array.from(iframes).find(frame => frame.contentWindow === window);

  return iframe;
};
